import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import keys from "lodash/keys";
import some from "lodash/some";
export default function createReducer(initialState, handlers) {
    const types = keys(handlers);
    if (some(types, t => isEmpty(t) || includes(t, "undefined"))) {
        throw new Error(`One or more incorrect action types were found in reducer handlers. Actions types are: ${types}`);
    }
    return function reducer(state = initialState, action) {
        return handlers[action.type] ? handlers[action.type](state, action) : state;
    };
}
